import { render, staticRenderFns } from "./dangerShelves.vue?vue&type=template&id=6bd41c72&scoped=true&"
import script from "./dangerShelves.vue?vue&type=script&lang=js&"
export * from "./dangerShelves.vue?vue&type=script&lang=js&"
import style0 from "./dangerShelves.vue?vue&type=style&index=0&id=6bd41c72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd41c72",
  null
  
)

export default component.exports